import React, { useState } from "react";
import {
  FaTachometerAlt,
  FaUsers,
  FaWarehouse,
  FaSnowflake,
  FaCogs,
  FaClipboardList,
  FaSlidersH,
  FaBell,
  FaCog,
  FaMapMarkerAlt,
  FaBox,   // ✅ nouvelle icône pour Conteneurs
  FaSignOutAlt
} from "react-icons/fa";
import "./Sidebar.css";

interface SidebarProps {
  photo?: string | null;
  first_name: string;
  last_name: string;
  role: "superadmin" | "ingenieur" | "technicien" | "ouvrier";
  activeMenu: string;
  setActiveMenu: (menu: string) => void;
  onLogout: () => void;
}

export default function Sidebar({
  photo,
  first_name,
  last_name,
  role,
  activeMenu,
  setActiveMenu,
  onLogout
}: SidebarProps) {
  const [collapsed, setCollapsed] = useState(false);

  const menusByRole: Record<string, { label: string; icon: React.ReactNode }[]> = {
    superadmin: [
      { label: "Gestion des utilisateurs", icon: <FaUsers /> },
    ],
    ingenieur: [
      { label: "Tableau de bord", icon: <FaTachometerAlt /> },
      { label: "Localisations", icon: <FaMapMarkerAlt /> },
      { label: "Entrepôts", icon: <FaWarehouse /> },
      { label: "Chambres froides", icon: <FaSnowflake /> },
      { label: "Groupes frigorifiques", icon: <FaCogs /> },
      { label: "Conteneurs", icon: <FaBox /> },   // ✅ ajouté
      { label: "Seuils", icon: <FaSlidersH /> },
      { label: "Relèves", icon: <FaClipboardList /> },
      { label: "Alertes", icon: <FaBell /> },
      { label: "Paramètres", icon: <FaCog /> },
    ],
    technicien: [
      { label: "Tableau de bord", icon: <FaTachometerAlt /> },
      { label: "Relèves", icon: <FaClipboardList /> },
      { label: "Conteneurs", icon: <FaBox /> },   // ✅ ajouté
      { label: "Alertes", icon: <FaBell /> },
      { label: "Paramètres", icon: <FaCog /> },
    ],
    ouvrier: [
      { label: "Tableau de bord", icon: <FaTachometerAlt /> },
      { label: "Relèves", icon: <FaClipboardList /> },
      { label: "Conteneurs", icon: <FaBox /> },   // ✅ ajouté
      { label: "Paramètres", icon: <FaCog /> },
    ],
  };

  const safeRole = menusByRole[role] ? role : "ouvrier";
  const safeMenus = menusByRole[safeRole] ?? [];


  return (
    <div className={`sidebar ${collapsed ? "collapsed" : ""}`}>
      <div className="sidebar-header">
        {photo ? (
          <img src={photo} alt="Profil" className="sidebar-photo" />
        ) : (
          <div className="sidebar-photo-placeholder">👤</div>
        )}
        {!collapsed && (
          <div className="sidebar-user">
            <h3>{first_name} {last_name}</h3>
            <p>{role}</p>
          </div>
        )}
        <button className="toggle-btn" onClick={() => setCollapsed(!collapsed)}>
          {collapsed ? "➤" : "◀"}
        </button>
      </div>

      <ul className="sidebar-menu">
        {safeMenus.map((menu) => (

          <li
            key={menu.label}
            className={`sidebar-item ${activeMenu === menu.label ? "active" : ""}`}
            onClick={() => setActiveMenu(menu.label)}
          >
            {menu.icon}
            {!collapsed && <span>{menu.label}</span>}
          </li>
        ))}
      </ul>

      <button className="sidebar-logout" onClick={onLogout}>
        <FaSignOutAlt />
        {!collapsed && <span>Déconnexion</span>}
      </button>
    </div>
  );
}

